/** Saudi IBAN, compared after stripping spaces and upper-casing — same rule as addPartyModal. */
export const IBAN_PATTERN = /^SA\d{22}$/;

/** Normalizes user input ("sa03 8000 ...") to the stored form ("SA038000..."). */
export const normalizeIban = (value: string) =>
  value
    .replace(/[^A-Za-z0-9]/g, "")
    .toUpperCase()
    .slice(0, 24);

/** Display form, in groups of four: "SA44 2000 0000 0123 4567 8912". */
export const formatIban = (value: string) =>
  normalizeIban(value)
    .replace(/(.{4})/g, "$1 ")
    .trim();

/** Short national address: four letters then four digits, e.g. RRRD1234. */
export const NATIONAL_ADDRESS_PATTERN = /^[A-Z]{4}[0-9]{4}$/;

export const normalizeNationalAddress = (value: string) =>
  value
    .replace(/[^A-Za-z0-9]/g, "")
    .toUpperCase()
    .slice(0, 8);

/** Saudi commercial register (CR) number: 10 digits. */
export const CR_NUMBER_PATTERN = /^\d{10}$/;
export const CR_NUMBER_LENGTH = 10;

/** Saudi unified national number ("700 number"): 10 digits starting with 7. */
export const UNIFIED_NUMBER_PATTERN = /^7\d{9}$/;
export const UNIFIED_NUMBER_LENGTH = 10;

/** Backend limits on OrganizationBankAccountRequestDTO. */
export const MIN_BENEFICIARY_NAME_LENGTH = 3;
export const MAX_BENEFICIARY_NAME_LENGTH = 100;

/** The self-register flow only onboards Saudi businesses: SAR account, SA address. */
export const ORGANIZATION_ADDRESS_COUNTRY_CODE = "SA";
export const ORGANIZATION_BANK_CURRENCY = "SAR";
